<template>
<div v-if="!isHidden">
	<div class="voters-outer">
		<!-- <h2 class="voters-header">FIND A SCREENING</h2> -->
		<div class="voters-wrapper">
			<div class="voters-inner clearfix">
				<div class="voters-container">
					<div class="voters-top"></div>
						<div class="voters-middle"><a href="http://www.foxsearchlight.com/awards/the-shape-of-water/" target="_blank">FIND A SCREENING</a></div>
					<img class="voters-bottom" src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627709206/fsl/fancy-frame.png" alt="fancy-frame">
				</div>
	<!-- 			<div class="voters-container col-xs-6">
					<div class="voters-top"></div>
						<div class="voters-middle"><a href="http://www.foxsearchlight.com/fyc/film/the-shape-of-water/find-a-screening/" target="_blank">GUILD VOTERS</a></div>
					<img class="voters-bottom" src="../assets/fancy-frame.png" alt="fancy-frame">
				</div> -->
			</div>
		</div>
	</div>
</div>
</template>

<script>
export default {
	name: 'voters',
	data: function() {
		return {
			isHidden: false,
		}
	}
}

</script>


// WEBPACK FOOTER //
// Voters.vue?da4e7ee6